import { useEffect, useState } from "react";
import {
  Grid,
  Card,
  Typography,
  LinearProgress,
  Box,
  Chip,
} from "@mui/material";
import { getData } from "../../Services/getData";
import { endpoints, localUrlEnum } from "../../Utils/UrlEnum";
import { GroupedExamSets } from "../../Utils/Types";
import styles from "../../Styles/questionnaire.module.css";
import genericStyles from "../../Styles/genericStyles.module.css";
import { Vocabulary } from "../../Utils/Vocabulary";
import { useNavigate } from "react-router-dom";
import { isFreeSubscription } from "../../Utils/Utils";

export default function Questionnaire() {
  const examCateogory = localStorage.getItem("examCategory") || "B";
  const [groupedExamSets, setGroupedExamSets] = useState<GroupedExamSets>({});
  const navigate = useNavigate();
  const clientId = localStorage.getItem("clientId");

  useEffect(() => {
    getData(
      `${endpoints.examSets.main}/forClient/${clientId}?isFreeSubscription=${isFreeSubscription()}`
    ).then((response) => {
      if (response?.data) {
        setGroupedExamSets(response?.data);
      }
    });
  }, [examCateogory, clientId]);
  return (
    <div className={styles.questionnaireContainer}>
      <div className={styles.header}>
        <Typography
          variant="h4"
          className={`${styles.mainTitle} ${genericStyles.titleColor}`}
        >
          {Vocabulary.modParcurgereIntrebari}
        </Typography>
      </div>

      <Box className={styles.groupsContainer}>
        {Object.keys(groupedExamSets).length === 0 ? (
          <Box className={styles.noDataContainer}>
            <Typography variant="h6" className={styles.noDataText}>
              {Vocabulary.noDatasetsAvailable}
            </Typography>
          </Box>
        ) : (
          Object.entries(groupedExamSets).map(([productName, examSets]) => (
            <Box key={productName} className={styles.productGroup}>
              {productName !== "null" && (
                <Box className={styles.productHeader}>
                  <Typography variant="h5" className={styles.productTitle}>
                    {productName}
                  </Typography>
                  <Chip
                    label={`${examSets.length} ${
                      examSets.length === 1 ? "set" : "seturi"
                    }`}
                    className={styles.productBadge}
                    size="small"
                  />
                </Box>
              )}

              <Grid container spacing={3} className={styles.gridContainer}>
                {examSets.map((set) => {
                  const progress =
                    set.totalQuestions && set.answeredQuestions
                      ? Math.round(
                          (set.answeredQuestions / set.totalQuestions) * 100
                        )
                      : 0;
                  const isCompleted = progress === 100;

                  const hasQuestions =
                    set.totalQuestions && set.totalQuestions > 0;

                  return (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={set._id}>
                      <Card
                        className={`${styles.examCard} ${
                          isCompleted ? styles.completedCard : ""
                        } ${!hasQuestions ? styles.disabledCard : ""}`}
                        onClick={() => {
                          if (hasQuestions) {
                            navigate(
                              `${localUrlEnum.examQuestions}/${set._id}`
                            );
                          }
                        }}
                      >
                        <Typography
                          variant="h6"
                          className={`${styles.cardTitle} ${genericStyles.titleColor}`}
                        >
                          {set.name}
                        </Typography>

                        <Box className={styles.progressSection}>
                          <LinearProgress
                            variant="determinate"
                            value={progress}
                            className={`${styles.progressBar} ${
                              isCompleted ? styles.completedProgress : ""
                            }`}
                          />
                          <Typography
                            variant="body2"
                            className={styles.progressText}
                          >
                            {set.answeredQuestions || 0} / {set.totalQuestions}{" "}
                            întrebări parcurse ({progress}%)
                          </Typography>
                        </Box>

                        <Box className={styles.statsContainer}>
                          <Box className={styles.statItem}>
                            <Typography
                              variant="body2"
                              className={styles.correctStat}
                            >
                              {Vocabulary.correct}: {set.correctAnswers || 0}
                            </Typography>
                          </Box>
                          <Box className={styles.statItem}>
                            <Typography
                              variant="body2"
                              className={styles.incorrectStat}
                            >
                              {Vocabulary.incorrect}:{" "}
                              {(set.answeredQuestions || 0) -
                                (set.correctAnswers || 0)}
                            </Typography>
                          </Box>
                        </Box>
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
          ))
        )}
      </Box>
    </div>
  );
}
